import * as React from 'react';
import { cn } from '@core/utils/cn';

interface ImageProps {
    image?: string;
    alt?: string;
    height?: string;
    width?: string;
}

interface ActionProps {
    className?: string;
    children?: React.ReactNode;

    image?: ImageProps;
    disabled?: boolean;
    selected?: boolean;
    onClick?(): void;
}

export const Action = ({
    className,
    children,
    image,
    disabled,
    selected,
    onClick
}: ActionProps) => (
    <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className={cn(
            'overflow-hidden rounded-xl border bg-card text-left text-card-foreground transition-colors hover:bg-accent disabled:cursor-not-allowed disabled:opacity-60',
            selected && 'border-primary bg-primary/10 hover:bg-primary/15',
            className
        )}
    >
        {image && (
            <img
                src={image.image}
                alt={image.alt ?? ''}
                style={{ height: image.height, width: image.width }}
                className="object-cover"
            />
        )}
        {children && <div className="p-4">{children}</div>}
    </button>
);
